import React from 'react';
import Navbar from '../components/Navbar';
import ScottyHero from '../components/ScottyHero';
import ScottyFeatures from '../components/ScottyFeatures';
import ScottyIntegration from '../components/ScottyIntegration';

const ScottyPage = () => {
  return (
    <div className="min-h-screen bg-white font-sans text-slate-900">
      <Navbar />
      <main>
        <ScottyHero />
        
        {/* Statistics / Value Prop Banner */}
        <section className="py-24 bg-white border-y border-slate-100">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-5xl font-extrabold text-slate-900 mb-8 leading-tight">
              Scale Your Event Support <br />
              <span className="text-violet-600">Without Scaling Your Team.</span>
            </h2>
            <p className="text-slate-600 text-xl max-w-3xl mx-auto mb-12 leading-relaxed">
              Organizers using Scotty see a 40% reduction in support tickets and a 15% lift in ticket sales through instant FAQ resolution.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              {[
                { label: "Lost Leads Saved", value: "24/7" },
                { label: "Cost Reduction", value: "65%" },
                { label: "Setup Time", value: "< 5m" }
              ].map((stat, i) => (
                <div key={i} className="bg-violet-50 p-8 rounded-2xl border border-violet-100">
                  <p className="text-violet-600 text-4xl font-black mb-2">{stat.value}</p>
                  <p className="text-violet-900/60 text-xs font-bold uppercase tracking-widest">{stat.label}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <ScottyFeatures />
        <ScottyIntegration />
      </main>
    </div>
  );
};

export default ScottyPage;